var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { DropdownItemWrapperStyled, DropdownWrapperStyled, DropdownItemStyled, DropdownLabelStyled, DropdownButtonStyled, } from './styled';
import Icon from '../Icon';
const Dropdown = (_a) => {
    var props = __rest(_a, []);
    const { value: valueProp, label, disabled, getOptionLabel, options, placeholder, open: openProps, onChange: onChangeProps, desktopMode, hideLabel } = props, rest = __rest(props, ["value", "label", "disabled", "getOptionLabel", "options", "placeholder", "open", "onChange", "desktopMode", "hideLabel"]);
    const [value, setValue] = useState(valueProp);
    const [open, setOpen] = useState(openProps || false);
    const handleClick = (item) => {
        if (onChangeProps)
            onChangeProps(item);
        setValue(item);
        setOpen(false);
    };
    const getValueLabel = () => {
        if (value) {
            return getOptionLabel ? getOptionLabel(value) : `${value}`;
        }
        return placeholder;
    };
    useEffect(() => {
        if (valueProp !== value) {
            setValue(valueProp);
        }
    }, [valueProp]);
    return (_jsxs(DropdownWrapperStyled, Object.assign({ desktopMode: desktopMode }, rest, { children: [!hideLabel && (_jsx(DropdownLabelStyled, Object.assign({}, rest, { children: _jsx("p", { children: label }) }))), _jsxs(DropdownButtonStyled, Object.assign({ desktopMode: desktopMode, disabled: disabled, "data-testid": "dropdownButton", open: open, onClick: () => setOpen(!open) }, { children: [_jsx("p", Object.assign({ style: { color: value ? '#0057B8' : '#5B5D71' } }, { children: getValueLabel() })), _jsx("div", Object.assign({ style: open
                            ? { transform: 'rotate(180deg)', transitionDuration: '0.5s' }
                            : { transform: 'rotate(360deg)', transitionDuration: '0.5s' } }, { children: _jsx(Icon, Object.assign({ name: "arrowDownSpecial" }, (value ? { color: '#0057B8' } : {}))) }))] })), _jsx(DropdownItemWrapperStyled, Object.assign({ open: open, desktopMode: desktopMode }, rest, { children: _jsx("div", Object.assign({ style: {
                        display: 'flex',
                        flexDirection: 'column',
                    } }, { children: options.map((item, index) => {
                        return (_jsx(DropdownItemStyled, Object.assign({ desktopMode: desktopMode, "data-testid": "dropdownItem" }, rest, { onClick: () => {
                                handleClick(item);
                            } }, { children: _jsx("p", { children: getOptionLabel ? getOptionLabel(item) : `${item}` }) }), `${item}-${index}`));
                    }) })) }))] })));
};
Dropdown.defaultProps = {
    options: [],
    desktopMode: false,
};
export default Dropdown;
//# sourceMappingURL=index.js.map